import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-feed-profit',
  templateUrl: './feed-profit.component.html',
  imports: [RouterOutlet],
})
export class FeedProfitComponent {}
